export default __webpack_public_path__ + "static/ai-marketing-8-b1135a5d7c977fedb2653dd6b61c5f3c.webp";